import Session from './B2b/Session';
import Groups from './B2b/Groups';
import CartOps from './B2b/CartOps';
import Orders from './B2b/Orders';

export default {
  ...Session,
  ...Groups,
  ...CartOps,
  ...Orders
};
